<template>
    <div class="body_contain">
        <el-row>
            <el-col :span="24">
                <div class="chart_title">
                    <span>全国物流人才需求动态展示平台</span>
                    <div class="time">{{data.starttime + " 至 " + data.endtime}}</div>
                </div>
            </el-col>
        </el-row>
        <el-row>
            <el-col :span="4">
                <div class="province_list">
                    <el-row>
                        <el-col :span="22" v-for="(o, index) in data.provinces" :offset="1">
                            <div class="province_card">
                                <span class="province_name">{{o.name}}</span>
                                <div class="province_bottom">
                                    <div>人才需求量：{{o.value}}人</div>
                                    <div>平均薪资：{{Number(o.pay_avg).toFixed(2)}}元</div>
                                </div>
                            </div>
                        </el-col>
                    </el-row>
                </div>
            </el-col>
            <el-col :span="10">
                <div id="china_map" class="map"></div>
            </el-col>
            <el-col :span="10">
                <div>
                    <el-row>
                        <el-col :span="24">
                            <div class="business_title">
                                <span><i class="el-icon-d-arrow-right"></i> 物流各类别人才需求量</span>
                            </div>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="8" v-for="(o, index) in data.sorts">
                            <div class="business_card">
                                <span class="business_name">{{o.name}}</span>
                                <div class="business_bottom">
                                    <div>
                                        <i :class="iconList[index]"></i>
                                    </div>
                                    <div>
                                        <div>人才需求量</div>
                                        <div>{{o.value}} <span>人</span></div>
                                    </div>
                                </div>
                            </div>
                        </el-col>
                    </el-row>
                </div>
            </el-col>
        </el-row>
        <el-row>
            <el-row :gutter="2">
                <el-col :span="6">
                    <div class="c_part">
                        <div class="c_title">
                            <span><i class="el-icon-d-arrow-right"></i> 按学历统计</span>
                        </div>
                        <div id="chartOne" class="c_chart"></div>
                    </div>
                </el-col>
                <el-col :span="6">
                    <div class="c_part">
                        <div class="c_title">
                            <span><i class="el-icon-d-arrow-right"></i> 能力关键词</span>
                        </div>
                        <div id="chartTwo" class="c_chart">
                            <wordcloud
                                :data="wordData"
                                nameKey="name"
                                valueKey="value"
                                :margin="{top:0,bottom:0,left:0,right:0}"
                                :fontSize="[20, 50]"
                                :color="wordColors"
                                :showTooltip="false">
                            </wordcloud>
                        </div>
                    </div>
                </el-col>
                <el-col :span="6">
                    <div class="c_part">
                        <div class="c_title">
                            <span><i class="el-icon-d-arrow-right"></i> 近6个月岗位群人才需求量</span>
                        </div>
                        <div id="chartThree" class="c_chart"></div>
                    </div>
                </el-col>
                <el-col :span="6">
                    <div class="c_part">
                        <div class="c_title">
                            <span><i class="el-icon-d-arrow-right"></i> 热门岗位TOP10</span>
                        </div>
                        <div id="chartFour" class="c_chart" style="overflow:auto">
                            <el-carousel height="360px" direction="vertical" :autoplay="true">
                                <el-carousel-item>
                                    <div class="business2_card" v-for="(o,index) in data.topJob" v-if="index < 3">
                                        <span class="business2_name">{{o.name}}</span>
                                        <div class="business2_bottom">
                                            <div>
                                                <i class="el-icon-user"></i>
                                            </div>
                                            <div>
                                                <div>平均薪资水平</div>
                                                <div>{{Number(o.pay_avg).toFixed()}} <span>元</span></div>
                                            </div>
                                        </div>
                                    </div>
                                </el-carousel-item>
                                <el-carousel-item>
                                    <div class="business2_card" v-for="(o,index) in data.topJob" v-if="index > 2 && index < 6">
                                        <span class="business2_name">{{o.name}}</span>
                                        <div class="business2_bottom">
                                            <div>
                                                <i class="el-icon-user"></i>
                                            </div>
                                            <div>
                                                <div>平均薪资水平</div>
                                                <div>{{Number(o.pay_avg).toFixed()}} <span>元</span></div>
                                            </div>
                                        </div>
                                    </div>
                                </el-carousel-item>
                                <el-carousel-item>
                                    <div class="business2_card" v-for="(o,index) in data.topJob" v-if="index > 5 && index < 9">
                                        <span class="business2_name">{{o.name}}</span>
                                        <div class="business2_bottom">
                                            <div>
                                                <i class="el-icon-user"></i>
                                            </div>
                                            <div>
                                                <div>平均薪资水平</div>
                                                <div>{{Number(o.pay_avg).toFixed()}} <span>元</span></div>
                                            </div>
                                        </div>
                                    </div>
                                </el-carousel-item>
                                <el-carousel-item>
                                    <div class="business2_card" v-for="(o,index) in data.topJob" v-if="index > 8">
                                        <span class="business2_name">{{o.name}}</span>
                                        <div class="business2_bottom">
                                            <div>
                                                <i class="el-icon-user"></i>
                                            </div>
                                            <div>
                                                <div>平均薪资水平</div>
                                                <div>{{Number(o.pay_avg).toFixed()}} <span>元</span></div>
                                            </div>
                                        </div>
                                    </div>
                                </el-carousel-item>
                            </el-carousel>
                        </div>
                    </div>
                </el-col>
            </el-row>
        </el-row>
    </div>
</template>

<script>
import echarts from "echarts";
import 'echarts/map/js/china.js';
import data from './data/wl';
import wordcloud from 'vue-wordcloud'

export default {
    name: "tourism",
    components: {
        wordcloud,
    },
    data() {
        return {
            data:data,
            wordColors: [],
            wordData: [],
            count: 10,
            sortType:['物流','仓储','运输'],
            iconList:['el-icon-map-location','el-icon-box','el-icon-truck'],
            chartThreeTime:['', '', '', '', '', ''],
        };
    },
    computed: {
    },
    mounted() {
        this.$nextTick(() => {
            this.initEchartMap();
            this.initEchartOne();
            this.initEchartTwo();
            this.initEchartThree();
        });
    },
    methods: {
        //初始化中国地图
        initEchartMap() {
            let optionMap = {
                layoutCenter: ['40%', '50%'],
                layoutSize: "100%",
                tooltip: {
                    triggerOn: "mousemove",   //mousemove、click
                    padding: 4,
                    borderWidth: 1,
                    borderColor: '#333333',
                    backgroundColor: 'rgba(0,0,0,0.8)',
                    textStyle: {
                        color: '#ffffff',
                        fontSize: 13
                    },
                },
                visualMap: {
                    min: 0, // 最小值
                    max: 60000, // 最大值
                    text: ['60000', '0'],
                    left:'right',
                    realtime: false,
                    calculable: false,
                    inRange: {
                        color: ['#FFFEDB', '#ffc107','#ff9800'] // 渐变颜色
                    },
                    textStyle: {
                        color: '#ffffff',
                        fontSize: 10
                    },
                },
                geo: {
                    map: "china",
                    // scaleLimit: {
                    //     min: 1,
                    //     max: 2
                    // },
                    zoom: 1.2,
                    top: 120,
                    label: {
                        normal: {
                            show: true,
                            fontSize: "10",
                            textStyle:{
                                color: "#333333"
                            }
                        },
                        emphasis: {
                            show: true,
                            fontSize: "10",
                            textStyle:{
                                color: "#ffffff"
                            }
                        }
                    },
                    itemStyle: {
                        normal: {
                            areaColor:"#FFEEE4",
                            borderColor: "rgba(255,255,255,0.9)",
                        },
                        emphasis: {
                            areaColor: "#1f77b4",
                            shadowOffsetX: 0,
                            shadowOffsetY: 0,
                            borderWidth: 0
                        }
                    }
                },
                series: [
                    {
                        name: "人才需求分布",
                        type: "map",
                        geoIndex: 0,
                        data: data.provinces
                    }
                ]
            };
            let mapDiv = document.getElementById('china_map');
            let myChart = echarts.init(mapDiv);
            myChart.setOption(optionMap);
        },
        initEchartOne() {
            let option = {
                color: ['#f8aba6', '#f6f5ec', '#fab27b', '#fcf16e', '#94d6da', '#abc88b','#7bbfea'],
                legend: {
                    top: '5%',
                    textStyle:{
                        color:'#fff'
                    }
                },
                series: [
                    {
                        name: '招聘信息',
                        type: 'pie',
                        radius: ['45%', '75%'],
                        top:'10%',
                        avoidLabelOverlap: false,
                        itemStyle: {
                            borderRadius: 10,
                            borderColor: '#fff',
                            borderWidth: 1
                        },
                        label: {
                            show: false,
                            position: 'center'
                        },
                        emphasis: {
                            label: {
                                show: true,
                                fontSize: '18',
                                formatter: '{b}:{c}人'
                            },
                        },
                        labelLine: {
                            show: true
                        },
                        data: data.edus
                    }
                ]
            };

            let chart = document.getElementById('chartOne');
            let myChart = echarts.init(chart);
            myChart.setOption(option);
        },
        initEchartTwo() {
            this.wordColors = ['#ffc107', '#ffeb3b', '#cddc39', '#8bc34a'];
            this.wordData = [
                {
                    "name": "派送",
                    "value": 9006
                },
                {
                    "name": "拣货",
                    "value": 4322
                },
                {
                    "name": "系统",
                    "value": 4224
                },
                {
                    "name": "验收",
                    "value": 2778
                },
                {
                    "name": "扫描",
                    "value": 2269
                },
                {
                    "name": "打包",
                    "value": 2208
                },
                {
                    "name": "陈列摆放",
                    "value": 1904
                },
                {
                    "name": "抗压",
                    "value": 1819
                },
                {
                    "name": "细心",
                    "value": 1783
                },
                {
                    "name": "复核",
                    "value": 1630
                },
                {
                    "name": "跟踪与监控",
                    "value": 1590
                },
                {
                    "name": "处理理赔",
                    "value": 1277
                },
                {
                    "name": "规划路线",
                    "value": 1076
                },
                {
                    "name": "沟通",
                    "value": 986
                },
                {
                    "name": "友好",
                    "value": 966
                },

            ];
        },
        initEchartThree(){
            let sort_type = this.sortType;
            let sort_value = new Array();
            let sort_pay_avg = new Array();
            for (let x = 0; x < sort_type.length; x++) {
                sort_value[x] = new Array();
                sort_pay_avg[x] = new Array();
                for (let y = 0; y < 6; y++) {
                    sort_value[x][y] = 0;
                    sort_pay_avg[x][y] = 0;
                }
            }
            let pos = 6;
            let lastName = '';
            data.pays.forEach((v,i)=>{
                sort_type.forEach((vv,ii)=>{
                    if (v.name != lastName) {
                        lastName = v.name;
                        pos = parseInt(pos) - 1;
                    }
                    if(v.jobsort == vv){
                        sort_value[ii][pos] = v.value;
                        sort_pay_avg[ii][pos] = v.pay_avg;
                        this.chartThreeTime[pos] = parseInt(v.name) + '月';
                    }
                });
            });
            let c_data = new Array();
            sort_type.forEach((v,i)=>{
                let s = {
                    // name: "需求量",
                    name: sort_type[i],
                    type: 'bar',
                    stack: 'total',
                    label: {
                        show: false
                    },
                    emphasis: {
                        focus: 'series'
                    },
                    data: sort_value[i]
                };
                c_data.push(s);
            });
            let option = {
                color: [ '#afb4db','#afdfe4', '#7bbfea'],
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {            // Use axis to trigger tooltip
                        type: 'shadow'        // 'shadow' as default; can also be 'line' or 'shadow'
                    }
                },
                legend: {
                    data: this.sortType,
                    top:'2%',
                    textStyle:{
                        color:'#ffffff',
                    }
                },
                grid: {
                    left: '2%',
                    right: '6%',
                    bottom: '3%',
                    containLabel: true
                },
                xAxis: {
                    type: 'value',
                    axisLabel:{
                        textStyle:{
                            color:'#ffffff',
                        }
                    }
                },
                yAxis: {
                    type: 'category',
                    data: this.chartThreeTime,
                    axisLabel:{
                        textStyle:{
                            color:'#ffffff',
                        }
                    }

                },
                series: c_data
            };
            let chart = document.getElementById('chartThree');
            let myChart = echarts.init(chart);
            myChart.setOption(option);

        },
    }
};
</script>
<style scoped>
.body_contain {
    width: 100%;
    height: 100%;
    padding: 0;
    margin: 0;
    background: -webkit-linear-gradient(#009688, #03d9c5); /* Safari 5.1 - 6.0 */
    background: -o-linear-gradient(#009688, #03d9c5); /* Opera 11.1 - 12.0 */
    background: -moz-linear-gradient(#009688, #03d9c5); /* Firefox 3.6 - 15 */
    background: linear-gradient(#009688, #03d9c5); /* 标准的语法（必须放在最后） */
}

.chart_title {
    width: 100%;
    height: 100px;
    margin: 0 0 10px 0;
    text-align: center;
    background-color: #2E2E2E;
    border-bottom:3px solid #41D3BD;
}

.time{
    font-size: 12px;
    color: #EAEAEA;
    position: absolute;
    z-index: 99;
    right:8px;
    bottom:24px;
}

.chart_title span {
    font-size: 30px;
    color: #ffffff;
    line-height: 100px;
    font-family: ".PingFang SC";
}

.province_list {
    width: 100%;
    height: 360px;
    overflow-x: hidden;
    overflow-y: auto;
}

.province_card {
    width: 100%;
    margin: 2px 0;
    background-color: rgba(0, 0, 0, 0.6);
}

.province_name {
    font-size: 16px;
    line-height: 32px;
    color: #ffffff;
    text-align: center;
    padding: 8px;
}

.province_bottom {
    width: 100%;
    border-bottom: 1px solid rgba(0, 0, 0, 0.6);
}

.province_bottom div {
    padding: 0 0 0 30px;
    font-size: 13px;
    line-height: 32px;
    background-color: #036e64;
    color: #EAEAEA;
}

.map {
    width: 100%;
    height: 360px;
}

.business_title {
    width: 100%;
    height: 60px;
    text-align: right;
}

.business_title span {
    font-size: 20px;
    color: #ffffff;
    line-height: 60px;
    font-family: ".PingFang SC";
    padding-right: 10px;
}

.business_card {
    width: 100%;
    height: 150px;
    background-color: rgba(0, 0, 0, 0.4);
}

.business_name {
    font-size: 16px;
    line-height: 50px;
    color: #ffffff;
    text-align: center;
    padding-left: 10px;
}

.business_bottom {
    width: 96%;
    margin: auto auto;
    background-color: #036e64;
    height: 90px;
}

.business_bottom > div {
    width: 50%;
    float: left;
    padding: 0;
    margin: 0;
}

.business_bottom div i {
    font-size: 70px;
    color: rgba(255, 255, 255, 0.3);
    padding-left: 10px;
    position: relative;
    top: 18px;
}

.business_bottom div div {
    font-size: 15px;
    text-align: right;
    color: #ffffff;
    line-height: 40px;
    padding: 0 6px;
}

.business_bottom div div span {
    font-size: 8px;
    text-align: right;
    color: #ffffff;
    line-height: 30px;
}

.business_bottom div div:first-child {
    font-size: 16px;
    font-weight: bold;
    color:#dfe980;
    line-height: 50px;
}

.c_part {
    width: 100%;
    height: 400px;
    background-color: #009688;
    border-right: 1px solid rgba(255, 255, 255, 0.28);
}
.c_title {
    width:100%;
    height:40px;
    background-color: rgba(0, 0, 0, 0.6);
}
.c_title span{
    font-size: 18px;
    color: #ffffff;
    line-height: 40px;
    font-family: ".PingFang SC";
    padding-left: 10px;
}

.c_chart {
    width: 100%;
    height: 360px;
}

.business2_card {
    width: 100%;
    height: 120px;
    background-color: rgba(0, 0, 0, 0.4);
}

.business2_name {
    font-size: 16px;
    line-height: 40px;
    color: #ffffff;
    text-align: center;
    padding-left: 20px;
}

.business2_bottom {
    width: 90%;
    margin: auto auto;
    background-color: #009688;
    height: 70px;
}

.business2_bottom > div {
    width: 50%;
    float: left;
    padding: 0;
    margin: 0;
}

.business2_bottom div i {
    font-size: 60px;
    color: rgba(255, 255, 255, 0.3);
    padding-left: 10px;
    position: relative;
    top: 10px;
}

.business2_bottom div div {
    font-size: 15px;
    text-align: right;
    color: #ffffff;
    line-height: 35px;
    padding: 0 6px;
}

.business2_bottom div div span {
    font-size: 8px;
    text-align: right;
    color: #ffffff;
    line-height: 30px;
}

.business2_bottom div div:first-child {
    font-size: 16px;
    font-weight: bold;
    color: #dfe980;
    line-height: 40px;
}
</style>
